import request from 'utils/request'
/*---------  用户管理    -------*/

//获取用户列表
export const getBusinessTableData = data => request().post('user/page', data)
//添加用户
export const addUser = data => request().post('user/add', data)
//获取角色列表
export const getRoleList = () => request().get('role/list')

//获取权限级别
export const getPermissionLevels = () =>
  request().get('role/listPermissionLevels')
//获取权限配置
export const getMenuList = () => request().get('menu/list')
//新增角色
export const addRole = data => request().post('role/add', data)
//冻结
export const setFrozen = id => request().get(`user/frozen/${id}`)
//激活
export const setUnfrozen = id => request().get(`user/unfrozen/${id}`)

//配置查询
export const queryConfig = id => request().get(`business/queryConfig/${id}`)

//配置保存
export const setConfig = data => request().post('business/config/', data)

//获取业务类型
export const getJsonList = () => request().get('business/jsonList')
